<template>
  <div :class="ready && wjData.type === '普通调查' ? 'container myQuestionnaireView' : 'container'">
    <div class="ME_V" v-if="ready && wjData.type === '普通调查'">
      <div class="ME_V_score">
        <div class="score"><span>{{wjData.totalscore}}</span>分</div>
        <div>您的问卷得分</div>
      </div>
      <div class="MQ_V_item">
        <div class="MQ_V_username">
          <h3>{{$store.state.userinfo.name}}</h3>
          <p>2020.03.09 16:20:20</p>
        </div>
<!--         <div class="MQ_V_list">
          <div class="title">参考标准</div>
          <div class="MQ_V_table">
            <div class="MQ_V_tr">
              <span>得分</span>
              <span>掌握程度</span>
            </div>
            <div class="MQ_V_tr">
              <span>0 - 30</span>
              <span>初级阶段</span>
            </div>
            <div class="MQ_V_tr">
              <span>31 - 60</span>
              <span>中级阶段</span>
            </div>
            <div class="MQ_V_tr">
              <span>61 - 100</span>
              <span>高级阶段</span>
            </div>
          </div>
        </div> -->
        <div class="MQ_V_list">
          <div class="title">结果分析</div>
          <div class="MQ_V_analyze">
            {{wjData.analysecontent}}
          </div>
        </div>
      </div>
    </div>
    <div class="ME_V_Vote" v-if="ready && wjData.type === '投票'">
      <div class="questionnaireHeader">
        <img src="../../../assets/images/question4.jpg" alt="">
        <div class="title">{{wjData.title}}</div>
        <div class="summary" v-html="wjData.summary"></div>
      </div>
      <div class="questionnaireBody">
        <div class="question-list">
          <!-- <div class="question-title">{{item.questionname}}</div> -->
          <div class="Qranking-wrapper">
            <div class="Qranking-list" v-for="option in wjData.wjStatisticsBeanList" :key="option.id">
<!--               <img v-if="option.logo" class="logo" :src="option.logo" alt="">
              <div class="content" v-html="option.content"></div> -->
              <div v-if="option.logo" class="logo" :style="{backgroundImage: 'url(' + option.logo + ')'}"></div>
              <div class="content">
                <div class="content_val" v-html="option.content"></div>
                <span class="more" @click.stop="seemore(option.content)">「查看详情」</span>
              </div>
              <div class="num">{{option.num}}票</div>
            </div>
          </div>
        </div>
      </div>
      <van-popup v-model="show" class="questionnaire_popup">
        <div class="questionnaire_popup_header">
          <van-icon name="cross" @click="closePopup" />
        </div>
        <div class="questionnaire_popup_body" v-html="nowShow"></div>
      </van-popup>
    </div>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  import $ from 'jquery'
  export default {
    name: 'myQuestionnaireView',
    data () {
      return {
        show: false,
        nowShow: '',
        wjData: {},
        ready: false
      }
    },
    created () {
      this.$toast.allowMultiple();
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true
      })
      this.$fetch.get(API.MEMBERWJRESULTDETAIL, {
        wjresultid: this.$route.query.id
      }).then(response => {
        // console.log(response)
        if (response.status !== 200) {
          var message = response.message ? response.message : '考试详情获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        this.ready = true
        this.wjData = response.data
        this.$nextTick(function () {
          $(".content").each(function(index, el) {
            if ($(el).height() > 120) {
              $(el).height(120)
              $(el).find('.more').show()
            }
          })
        })
        load.clear()
      }).catch(error => {
        console.log()
        load.clear()
      })
    },
    methods: {
      seemore (val) {
        this.nowShow = val
        this.show = true
        return false
      },
      closePopup () {
        this.show = false
      }
    }
  }
</script>

<style lang="stylus">
</style>